"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubConnaissancesMarcheImmobilierCorporation = void 0;
exports.ESubConnaissancesMarcheImmobilierCorporation = {
    aucune: "aucune",
    faible: "faible",
    moyenne: "moyenne",
    eleve: "eleve",
    expert: "expert",
};
